import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import ReactQueryProvider from './providers/ReactQueryProvider';
import { isIos } from './utils/isIos';
import './App.css';
import GrowthBookProviderWrapper from './providers/GrowthBookProviderWrapper';
import useRemoveVerifyParam from './hooks/useRemoveVerifyParam';
import MainLayout from './MainLayout';

const App = () => {
  useRemoveVerifyParam(); // Redirection url from BKASH contains parameter "verify" which contains symbols that break the app

  useEffect(() => {
    if (isIos()) {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
      }
    }
  }, []);

  return (
    <GrowthBookProviderWrapper>
      <ReactQueryProvider>
        <>
          <ReactQueryDevtools initialIsOpen={false} />
          <MainLayout />
        </>
      </ReactQueryProvider>
    </GrowthBookProviderWrapper>
  );
};

export default App;
